import PropTypes from "prop-types";
import { forwardRef } from "react";
import Value from "./value/Value";
import { QuantityValueStyled } from "./QuantityValue.styled";
import Quantity from "./quantity/Quantity";

const QuantityValue = forwardRef(({ id }, ref) => {
    return (
        <QuantityValueStyled ref={ref}>
            <Quantity id={id} />
            <Value id={id} />
        </QuantityValueStyled>
    );
});

QuantityValue.displayName = "QuantityValue";

QuantityValue.defaultProps = {
    id: undefined
};

QuantityValue.propTypes = {
    id: PropTypes.string
};

export default QuantityValue;
